import { useMemo } from 'react';
import { COLUMN_DEFINITIONS, ColumnDefinition, regFieldId } from '../../components/listsv2/profile-column-definitions';

type RegistrationField = { registration_question: number; name?: string | null };

export function useVisibleColumns(
  columnOrder: string[],
  enabledColumns: string[],
  registrationFields: RegistrationField[] | null | undefined
): ColumnDefinition[] {
  return useMemo(() => {
    const regFieldLookup = new Map((registrationFields ?? []).map((f) => [regFieldId(f.registration_question), f]));
    return columnOrder
      .filter((id) => enabledColumns.includes(id))
      .flatMap((id): ColumnDefinition[] => {
        const staticDef = COLUMN_DEFINITIONS.find((c) => c.id === id);
        if (staticDef) return [staticDef];
        const regField = regFieldLookup.get(id);
        if (regField)
          return [
            {
              id,
              label: regField.name ?? '',
              sortKey: `profile.${regField.registration_question}`,
              columnWidth: '100px',
              isRemovable: true,
              registrationQuestion: regField.registration_question,
            },
          ];
        return [];
      });
  }, [columnOrder, enabledColumns, registrationFields]);
}
